import PrintProductSizeRoesConfiguratorSampleModal, {
  PRINT_PRODUCT_SIZE_ROES_CONFIGURATOR_SAMPLE_MODAL,
} from './modal';

export { PRINT_PRODUCT_SIZE_ROES_CONFIGURATOR_SAMPLE_MODAL };

export default PrintProductSizeRoesConfiguratorSampleModal;
